import { render } from "./IconWarranty.vue?vue&type=template&id=7bfb7f07"
import script from "./IconWarranty.vue?vue&type=script&lang=js"
export * from "./IconWarranty.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__